import Colors from 'enums/Colors';
import styled from 'styled-components';

const ReportsStyled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        gap: 2rem;
        margin-left: 180px;
        margin-top: 60px;
    `,

    Title: styled.h1`
        font-size: 32px;
        font-weight: 700;
        color: ${Colors.Blue};
    `,

    ContentReports: styled.div`
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
    `,

    CardOption: {
        Container: styled.div`
            display: flex;
            flex-direction: column;
            gap: 2rem;
            min-width: 360px;
            min-height: 200px;
            padding: 20px;
            border-radius: 10px;
            background-color: white;

        `,

        Title: styled.h1`
            font-size: 26px;
            font-weight: 700;
            color: ${Colors.Blue};
            text-decoration: underline;
            text-underline-offset: calc(1rem);
        `,

        Content: styled.div`
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        `
    },
};

export default ReportsStyled;
